import { Divider, Stack } from '@mui/material';

import { ActionButton } from '@/components';

type PageHeaderProps = {
  actionButtonLabel: string;
  onButtonClick: () => void;
};

export const PageHeader = ({ actionButtonLabel, onButtonClick }: PageHeaderProps) => (
  <Stack direction="column" justifyContent="center" alignItems="flex-end">
    <Stack
      direction="row"
      justifyContent="end"
      alignItems="center"
      sx={{ width: '100%', margin: '24px 0', padding: '0 40px' }}
    >
      <ActionButton
        actionType="ACTION"
        label={actionButtonLabel}
        plusIcon={true}
        onClick={onButtonClick}
      />
    </Stack>
    <Divider sx={{ width: '100%' }} />
  </Stack>
);
